// extracted by mini-css-extract-plugin
module.exports = {"container":"partnercard-module--container--1hmGZ","heading":"partnercard-module--heading--2q4d9","description":"partnercard-module--description--1b6XY"};